import { render } from "./TableAntrianMultipleResponsiveWithout.vue?vue&type=template&id=6b6036f6"
import script from "./TableAntrianMultipleResponsiveWithout.vue?vue&type=script&lang=js"
export * from "./TableAntrianMultipleResponsiveWithout.vue?vue&type=script&lang=js"

import "./TableAntrianMultipleResponsiveWithout.vue?vue&type=style&index=0&id=6b6036f6&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__